wbApp.controller('SettingsSettingsCtrl', ['$scope', '$q', '$translate', 'tenantSettingSvc', 'dataExportSettingSvc', 'notificationSvc', 'tenantInfo',
function ($scope, $q, $translate, tenantSettingSvc, dataExportSettingSvc, notificationSvc, tenantInfo) {

    var isActive = false;
    var loaded = false;

    $scope.isFranchiseCentral = tenantInfo.isFranchiseCentral;
    $scope.isFranchiseCentralAndSupportSubjectLicenses = tenantInfo.isFranchiseCentral && tenantInfo.franchiseCentralSettings.supportSubjectLicenses;

    function loadData() {
        $scope.isBusy = true;
        $scope.tenantSetting = {};
        $scope.tenantSettingSrc = tenantSettingSvc.getAsync();
        $scope.dataExportSetting = dataExportSettingSvc.getAsync();
        $q.all([$scope.dataExportSetting.$promise, $scope.tenantSettingSrc.$promise]).then(function () {
            $scope.tenantSetting = angular.copy($scope.tenantSettingSrc);
            $scope.tenantSettingOrig = angular.copy($scope.tenantSettingSrc);
            $scope.dataExportSettingOrig = angular.copy($scope.dataExportSetting);

            $scope.isBusy = false;
        });
    }

    $scope.$on('refreshData', function (e, data) {
        if (isActive) {
            loadData();
        }
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;

                if (!loaded) {
                    loadData();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.onCancel = function () {
        loadData();
    }

    $scope.onModelSave = function (dataExportSettingData, data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        var updates = 0;

        if (!$scope.dataExportSettingIsUnchanged(dataExportSettingData)) {
            updates++;

            dataExportSettingSvc.update(dataExportSettingData, function (model) {
                $scope.dataExportSetting = model;
                $scope.dataExportSettingOrig = angular.copy($scope.dataExportSetting);

                updates--;
                if (!updates) {
                    $scope.isSaving = false;
                }
            }, function (errorResult) {
                updates--;
                if (!updates) {
                    $scope.isSaving = false;
                }

                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                    notificationSvc.translateError(errorResult));
            });
        }

        if (!$scope.tenantSettingIsUnchanged(data)) {
            updates++;

            tenantSettingSvc.getAsync().$promise.then(function (currentSetting) {

                var current = angular.copy(currentSetting);

                // Apply only data we are setting in on this tab
                current.enableUserRegistration = data.enableUserRegistration;
                current.defaultNationality = data.defaultNationality;
                current.quickUserRegistrationMode = data.quickUserRegistrationMode;
                current.courseInterestsSupport = data.courseInterestsSupport;
                current.allowClientActionRegistration = data.allowClientActionRegistration;
                current.coursePreviewOnlyRegistration = data.coursePreviewOnlyRegistration;
                current.sortNamesBySurname = data.sortNamesBySurname;
                current.showArrearInsteadOfPayments = data.showArrearInsteadOfPayments;
                current.showArrearInMyCourses = data.showArrearInMyCourses;
                current.enableZoomIntegration = data.enableZoomIntegration;
                current.readOnlyClientCourseRegistration = data.readOnlyClientCourseRegistration;
                current.allowClientCourseRegistration = data.allowClientCourseRegistration;
                current.allowShareOnFBForCourses = data.allowShareOnFBForCourses;
                current.allowShareOnFBForActions = data.allowShareOnFBForActions;
                current.enableSMSInWaitQueueAutoBooking = data.enableSMSInWaitQueueAutoBooking;
                current.showQuickNavOnHomePage = data.showQuickNavOnHomePage;
                current.disableExcuseInMyCourses = data.disableExcuseInMyCourses;
                current.courseRegistrationAgreement = data.courseRegistrationAgreement;
                current.noOfDaysToShowAction = data.noOfDaysToShowAction;
                current.showHealthInCourseRegistration = data.showHealthInCourseRegistration;
                current.showAttendantHealthInCourseRegistration = data.showAttendantHealthInCourseRegistration;
                current.sendApplicationForm = data.sendApplicationForm;
                current.showClassroomFilterInCourses = data.showClassroomFilterInCourses;
                current.showLessonsRemaining = data.showLessonsRemaining;                
                current.showNearestLessonInCourses = data.showNearestLessonInCourses;
                current.showPriceInCourseRegistration = data.showPriceInCourseRegistration;
                current.useTotalPriceForCourses = data.useTotalPriceForCourses;
                current.noteDescriptionInCourseRegistration = data.noteDescriptionInCourseRegistration;
                current.showCourseTypeFilterInCourses = data.showCourseTypeFilterInCourses;
                current.noOfAllowedOneOffs = data.noOfAllowedOneOffs;
                current.showNoteInCourseRegistration = data.showNoteInCourseRegistration;
                current.coursesSortByDate = data.coursesSortByDate;
                current.scheduleVisibleTimeStart = data.scheduleVisibleTimeStart;
                current.clientScheduleWeekView = data.clientScheduleWeekView;
                current.scheduleEnableAutoHourRange = data.scheduleEnableAutoHourRange;
                current.disableClientCalendar = data.disableClientCalendar;
                current.scheduleVisibleTimeEnd = data.scheduleVisibleTimeEnd;
                current.scheduleDayViewResourcesPerPage = data.scheduleDayViewResourcesPerPage;
                current.scheduleTimeScale = data.scheduleTimeScale;
                current.showAllCoursesInClientSchedule = data.showAllCoursesInClientSchedule;
                current.courseExcuseThresholdType = data.courseExcuseThresholdType;
                current.courseExcuseThreshold = data.courseExcuseThreshold;
                current.showContatInClientAttendance = data.showContatInClientAttendance;
                current.clientAttendanceShowStudentNote = data.clientAttendanceShowStudentNote;
                current.showArrearInClientAttendance = data.showArrearInClientAttendance;
                current.showNoteInClientAttendance = data.showNoteInClientAttendance;
                current.actionExcuseThresholdType = data.actionExcuseThresholdType;
                current.actionExcuseThreshold = data.actionExcuseThreshold;
                current.showAgeInClientAttenandace = data.showAgeInClientAttenandace;
                current.noOfHoursToUpdateAttendance = data.noOfHoursToUpdateAttendance;
                current.allowMultiAmends = data.allowMultiAmends;
                current.activityExcuseWithoutFoodThresholdType = data.activityExcuseWithoutFoodThresholdType;
                current.activityExcuseWithoutFoodThreshold = data.activityExcuseWithoutFoodThreshold;
                current.calcSnacksOnlyForPresent = data.calcSnacksOnlyForPresent;
                current.activityExcuseThresholdType = data.activityExcuseThresholdType;
                current.activityExcuseThreshold = data.activityExcuseThreshold;
                current.enableKindergartenSupport = data.enableKindergartenSupport;
                current.allowDiscounts = data.allowDiscounts;
                current.enableRfidCardSupport = data.enableRfidCardSupport;
                current.enableZoomIntegration = data.enableZoomIntegration;
                current.enableDataExport = data.enableDataExport;
                current.enableRfidAccessGroups = data.enableRfidAccessGroups;
                current.rfidBreakTresholdIntervalInMinutes = data.rfidBreakTresholdIntervalInMinutes;
                current.rfidValidateESFByLaw = data.rfidValidateESFByLaw;
                current.sendInfoCardWithCourseRegistration = data.sendInfoCardWithCourseRegistration;
                current.sendApplicationFormAction = data.sendApplicationFormAction;
                current.showExcusesAndAmendsInMyActivities = data.showExcusesAndAmendsInMyActivities;
                current.facebookPixelID = data.facebookPixelID;
                current.requireTeacherFranchiseLicenses = data.requireTeacherFranchiseLicenses;
                current.showAgeFilterInCourses = data.showAgeFilterInCourses;
                current.showScheduleInCourses = data.showScheduleInCourses;
                current.showAgeRangesInCourses = data.showAgeRangesInCourses;
                current.enablePaymentGateways = data.enablePaymentGateways;
                current.enableDuePaymentsInClient = data.enableDuePaymentsInClient;
                current.showOverpaymentsInClientDuePayments = data.showOverpaymentsInClientDuePayments;
                current.showDateInClientCourses = data.showDateInClientCourses;
                current.showAskQuestionInCourseRegistration = data.showAskQuestionInCourseRegistration;
                current.maxNumberOfActivityWaitQueueReservations = data.maxNumberOfActivityWaitQueueReservations;
                current.maxNumberOfCourseWaitQueueReservations = data.maxNumberOfCourseWaitQueueReservations;

                current.allowReferenceSource = data.allowReferenceSource;
                current.mandatoryStudentBirthday = data.mandatoryStudentBirthday;
                current.mandatoryStudentNationality = data.mandatoryStudentNationality;
                current.mandatoryUserAddress = data.mandatoryUserAddress;
                current.mandatoryUserNationality = data.mandatoryUserNationality;
                current.mandatoryStudentName = data.mandatoryStudentName;
                current.mandatoryEmail2 = data.mandatoryEmail2;
                current.mandatoryPhone2 = data.mandatoryPhone2;
                current.mandatoryStudentGender = data.mandatoryStudentGender;
                current.maxNoOfPreviewStudentsOnOneLesson = data.maxNoOfPreviewStudentsOnOneLesson;
                current.enableReservationSupport = data.enableReservationSupport;

                current.showCourseWaitQueueIndexInClient = data.showCourseWaitQueueIndexInClient;
                current.reservationExcuseThresholdType = data.reservationExcuseThresholdType;
                current.reservationExcuseThreshold = data.reservationExcuseThreshold;
                current.reservationTeacherHourSingleRate = data.reservationTeacherHourSingleRate;
                current.reservationTeacherHourGroupOneRate = data.reservationTeacherHourGroupOneRate;
                current.reservationTeacherGroupOneSizeFrom = data.reservationTeacherGroupOneSizeFrom;
                current.reservationTeacherGroupOneSizeTo = data.reservationTeacherGroupOneSizeTo;
                current.reservationTeacherHourGroupTwoRate = data.reservationTeacherHourGroupTwoRate;
                current.reservationTeacherGroupTwoSizeFrom = data.reservationTeacherGroupTwoSizeFrom;
                current.reservationTeacherGroupTwoSizeTo = data.reservationTeacherGroupTwoSizeTo;
                current.reservationCreateThresholdType = data.reservationCreateThresholdType;
                current.reservationCreateThreshold = data.reservationCreateThreshold;
                current.enableFullCourseInterest = data.enableFullCourseInterest;

                current.smallNurserySupport = data.smallNurserySupport;
                current.childrenGroupSupport = data.childrenGroupSupport;

                current.enableWalletSupport = data.enableWalletSupport;
                current.walletAccountingBook = data.walletAccountingBook;
                current.walletDepositExpirationInDays = data.walletDepositExpirationInDays;

                current.mandatoryStudentPersonalIDNumber = data.mandatoryStudentPersonalIDNumber;
                current.sendPaymentConfirmationForm = data.sendPaymentConfirmationForm;
                current.enableRentSupport = data.enableRentSupport;
                current.requireTermsAndConditionsAgreement = data.requireTermsAndConditionsAgreement;
                current.requireTradeTermsAgreement = data.requireTradeTermsAgreement;
                current.googleAnalyticsId = data.googleAnalyticsId;
                current.allowClientActionUnRegistrationInsteadOfExcuse = data.allowClientActionUnRegistrationInsteadOfExcuse;
                
                current.mandatoryStudentHealthInsurance = data.mandatoryStudentHealthInsurance;
                current.mandatoryStudentAddress = data.mandatoryStudentAddress;
                current.mandatoryStudentAllergies = data.mandatoryStudentAllergies;
                current.mandatoryStudentPlaceOfBirth = data.mandatoryStudentPlaceOfBirth;
                
                current.mandatoryUserIdentityCardNumber = data.mandatoryUserIdentityCardNumber;
                current.mandatoryUserPersonalIDNumber = data.mandatoryUserPersonalIDNumber;
                current.mandatoryUserNationality2 = data.mandatoryUserNationality2;
                current.mandatoryUserName2 = data.mandatoryUserName2;
                current.mandatoryUserSurname2 = data.mandatoryUserSurname2;
                current.mandatoryUserMiddleName2 = data.mandatoryUserMiddleName2;
                current.mandatoryUserAddress2 = data.mandatoryUserAddress2;
                current.mandatoryUserIdentityCardNumber2 = data.mandatoryUserIdentityCardNumber2;
                current.mandatoryUserPersonalIDNumber2 = data.mandatoryUserPersonalIDNumber2;
                current.mandatoryUserBirthday = data.mandatoryUserBirthday;
                current.mandatoryUserBirthday2 = data.mandatoryUserBirthday2;
                current.rfidAttendanceEUSupport = data.rfidAttendanceEUSupport;
                current.infoCardBackUseLogo = data.infoCardBackUseLogo;
                current.mandatoryStudentNotes = data.mandatoryStudentNotes;
                current.showNoteInEventRegistration = data.showNoteInEventRegistration;
                current.enableClientUserSchedules = data.enableClientUserSchedules;
                current.enableNewClientDesign = data.enableNewClientDesign;
                current.rfidLogoType = data.rfidLogoType;
                current.showCapacityInClientUserSchedules = data.showCapacityInClientUserSchedules;
                
                current.showEmailInClientAttendance = data.showEmailInClientAttendance;
                current.enableCashPayments = data.enableCashPayments;
                current.showFreePlacesInCourseDetail = data.showFreePlacesInCourseDetail;
                current.showRemainingLessonsInCourseDetail = data.showRemainingLessonsInCourseDetail;
                current.noteDescriptionInReservations = data.noteDescriptionInReservations;

                tenantSettingSvc.update(current, function (model) {
                    $scope.tenantSetting = angular.copy(model);
                    $scope.tenantSettingOrig = angular.copy(model);

                    updates--;
                    if (!updates) {
                        $scope.isSaving = false;
                    }
                }, function (errorResult) {
                    updates--;
                    if (!updates) {
                        $scope.isSaving = false;
                    }

                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult));
                });
            });
        }
    }

    $scope.tenantSettingIsUnchanged = function (data) {
        return angular.equals(data, $scope.tenantSettingOrig);
    }

    $scope.dataExportSettingIsUnchanged = function (data) {
        return angular.equals(data, $scope.dataExportSettingOrig);
    }

    $scope.detailIsUnchanged = function (dataExportSetting, tenantSettingData) {
        return $scope.dataExportSettingIsUnchanged(dataExportSetting) &&
            $scope.tenantSettingIsUnchanged(tenantSettingData);
    }

    $scope.onTriggerPortalUpdate = function () {
        tenantSettingSvc.triggerPortalUpdate();
    }
}]);
